import { useMemo, useState } from "react";
import { useClientsState } from "atoms/clientsAtom";
import { Client } from "types";
import { useSetAtom } from "jotai/index";

import { SearchInput } from "components/SearchInput/SearchInput";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import { Row } from "components/Row/Row";
import { MediumText } from "components/MediumText/MediumText";
import { Divider } from "components/Divider/Divider";
import { Paragraph } from "components/Paragraph/Paragraph";
import { Checkbox2 } from "components/Checkbox2/Checkbox2";

import { setClientModalAtom } from "../../../atoms/modalAtom/modalAtom";

import { useGetClients } from "../api";
import styles from "../styles.module.scss";
import { useFilteredClients } from "../hooks";

export const ClientsBody = (): JSX.Element => {
  const setClientModal = useSetAtom(setClientModalAtom);

  const { clientsState, setClientsState } = useClientsState();
  const [search, setSearch] = useState("");

  const { data: clients = [] } = useGetClients();

  const filteredClients = useFilteredClients(search, clients);

  const onItemClick = (item: Client) => {
    if (clientsState.activeItem?.clientid === item.clientid) {
      setClientModal(true);
    } else {
      setClientsState((prev) => ({
        ...prev,
        activeItem: item,
      }));
    }
  };

  const handleCheckUncheck = (item: Client) => {
    const isActive = clientsState.activeItems.some(
      (temp) => temp.clientid === item.clientid
    );

    if (isActive) {
      setClientsState((prev) => ({
        ...prev,
        activeItems: prev.activeItems.filter(
          (temp) => temp.clientid !== item.clientid
        ),
      }));
    } else {
      setClientsState((prev) => ({
        ...prev,
        activeItems: [...prev.activeItems, item],
      }));
    }
  };

  const handleCheckUncheckAll = () => {
    setClientsState((prev) => ({
      ...prev,
      activeItems:
        clientsState.activeItems.length === clients.length ? [] : [...clients],
    }));
  };

  const allChecked = useMemo(() => {
    return clients.length && clientsState.activeItems.length === clients.length;
  }, [clients, clientsState.activeItems]);

  return (
    <div className={styles.container}>
      <VerticalSpace size={8} />
      <div className="flex items-center justify-start w-full p-2">
        <div className="flex-1">
          <SearchInput callback={setSearch} />
        </div>
      </div>
      <Row>
        <Checkbox2 onChange={handleCheckUncheckAll} checked={allChecked} />
        <HorizontalSpace size={18} />
        <MediumText style={{ width: "400px" }}>ФИО/Наименование</MediumText>
        <MediumText style={{ width: "150px" }}>Телефон</MediumText>
        <MediumText style={{ width: "150px" }}>Процент скидки</MediumText>
      </Row>
      <Divider />
      {filteredClients.map((item: Client) => {
        const isActive = clientsState.activeItems.some(
          (temp) => temp.clientid === item.clientid
        );

        const isSelected = clientsState.activeItem?.clientid === item.clientid;

        return (
          <Row
            key={item.clientid}
            isActive={isSelected}
            onClick={() => onItemClick(item)}
          >
            <div
              onClick={(ev) => {
                ev.stopPropagation();
                handleCheckUncheck(item);
              }}
              className={styles.checkboxWrapper}
            >
              <Checkbox2
                checked={isActive}
                onClick={(ev) => {
                  ev.stopPropagation();
                }}
              />
            </div>
            <HorizontalSpace size={18} />
            <Paragraph width={400}>
              {item.firma === 0
                ? `${item.firstname} ${item.secondname}`
                : item.firstname}
            </Paragraph>
            <Paragraph width={150}>{item.phone}</Paragraph>
            <Paragraph width={150}>{item.percent}</Paragraph>
          </Row>
        );
      })}
    </div>
  );
};
